<p-toast></p-toast>

<div *ngIf="salesLead as sLead else loading">
  <p-toolbar styleClass="">
    <ng-template pTemplate="left">
      <app-confirm-delete-product-part [(display)]="confirmDeleteDocumentOn"
                                       [typeConfirmation]="true"
                                       [confirmText]="confirmDeleteDocumentText"
                                       (done)="onDeleteDocumentConfirmation($event)">
      </app-confirm-delete-product-part>

      <button pButton pRipple [label]="Delete" icon="pi pi-trash" class="p-button-danger" (click)="deleteDocumentClick($event)"
              [disabled]="!canDelete" pTooltip="Удалить документ" tooltipPosition="top"></button>

    </ng-template>

    <ng-template pTemplate="right">
    </ng-template>
  </p-toolbar>

  <p-panel header="Сделка (Проект): {{sLead.DOCREGID}}">
    <p-accordion [multiple]="true">

      <p-accordionTab [selected]="true">
        <ng-template pTemplate="header">
          <h5>Описание</h5>
        </ng-template>
        <div class="fluid formgrid grid" appStopAccordionHomeEnd>
          <div class="field col-2 xl:col-2 sm:col-6">
            <label for="DD" class="do-not-wrap-text">Дата создания</label>
            <p-calendar id="DD" dateFormat="dd.mm.yy" [(ngModel)]="SLCREATEDATE" (onSelect)="onDateSelect($event)" showButtonBar="true" [disabled]="salesLeadId" firstDayOfWeek="1"></p-calendar>
          </div>
          <div class="field col-2 xl:col-2 sm:col-6">
            <label for="DV" class="do-not-wrap-text">Дата изменения</label>
            <p-calendar id="DV" dateFormat="dd.mm.yy" [(ngModel)]="SLCHANGEPDATE" [disabled]="salesLeadId" firstDayOfWeek="1"></p-calendar>
          </div>
          <div class="field col-8 xl:col-8 sm:col-12">
            <app-personselector labelKey="Ответственный" [parentCompany]="mainCompanyId" [disabled]="salesLeadId" [selectedID]="responcePersonId" (selectedPersonID)="cliPersonSelected($event)"></app-personselector>
          </div>
          <div class="field col-12">
            <label for="DV1" class="do-not-wrap-text">Название</label>
            <input id="DV1" type="text" pInputText [(ngModel)]="sLead.DOCREGNAME" class="mb-2" />
          </div>
          <div class="field col-12">
            <label for="DV2" class="do-not-wrap-text">Описание</label>
            <input id="DV2" type="text" pInputText [(ngModel)]="sLead.DOCREGNOTE" class="mb-2" />
          </div>
          <div class="field col-12">
            <p-editor [(ngModel)]="sLead.DOCREGDESCRIPTION" [style]="{'height':'15vw'}"></p-editor>
          </div>
        </div>
        <div class="grid formgrid justify-content-end">
          <p-button label="Сохранить" icon="pi pi-check" (onClick)="onConfirm(1)" styleClass="ml-2 mt-2 mr-2" [disabled]="(formInvalid || noChangesThere)"></p-button>
        </div>
      </p-accordionTab>

      <p-accordionTab [selected]="salesLeadId" [disabled]="!salesLeadId">
        <ng-template pTemplate="header">
          <h5>Документы</h5>
        </ng-template>
        <app-edit-sales-lead-items appStopAccordionHomeEnd [showLabel]="false" [salesLeadId]="salesLeadId"></app-edit-sales-lead-items>
      </p-accordionTab>
    </p-accordion>

  </p-panel>
</div>
<ng-template #loading>
  <p>Информация загружается...</p>
</ng-template>
